import axios from 'axios';

// API Base URL - defaults to localhost:3005 for development
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3005';

// Create axios instance with default configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Important for sending/receiving cookies
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for logging and token handling
api.interceptors.request.use(
  (config) => {
    // You can add authorization headers here if needed
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Handle specific error codes
      switch (error.response.status) {
        case 401:
          // Unauthorized - clear local storage and redirect to login
          console.error('401 Unauthorized:', error.config?.url);
          console.error('Error message:', error.response?.data?.message);

          // Don't redirect if we're already on the login page or trying to login
          if (window.location.pathname !== '/login' && !error.config?.url?.includes('/api/auth/login')) {
            console.log('Redirecting to login due to 401...');
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            window.location.href = '/login';
            // Return a pending promise to prevent further error handling
            return new Promise(() => {});
          }
          break;
        case 403:
          console.error('Access forbidden');
          break;
        case 404:
          console.error('Resource not found');
          break;
        case 500:
          console.error('Server error');
          break;
        default:
          console.error('API Error:', error.response.data?.message || error.message);
      }
    } else if (error.request) {
      console.error('Network error - no response received');
      console.error('Request config:', error.config);
    } else {
      console.error('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE_URL };
